import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';
import qs from "qs";

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProduct(params) {
	return clientSupplier.get("api-supplier/supplier-product/data", {
		params: params,
	});
}

function exportDataProduct(params) {
	return clientSupplier.get("api-supplier/supplier-product/export", {
		params: params,
	});
}

function addDataProduct (params) {
	return clientSupplier.post("api-supplier/supplier-product/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editDataProduct (params) {
	return clientSupplier.post("api-supplier/supplier-product/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteDataProduct (params) {
	return clientSupplier.post("api-supplier/supplier-product/delete", qs.stringify({
		product_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getProductUnit() {
	return clientSupplier.get("api-supplier/options/product-unit");
}

export default {
	getDataProduct,
	exportDataProduct,
	addDataProduct,
	editDataProduct,
	deleteDataProduct,
	getProductUnit,
};